/* eslint-disable no-unused-vars */
import Api from "./_api";

class ContactService {
  constructor(rootVue) {
    this._rootVue = rootVue;
  }

  _processRes(res) {
    const data = res.res.data;
    if (data.errors) {
      throw data.errors;
    }
    return data;
  }
  //  this.getContactInfoDetail(10)
  getContactInfoDetail(id) {
    return Api.getContactInfoDetail(id).then(
      (res) => this._processRes(res),
      (err) => console.error(err)
    );
  }
  //  this.queryContactInfoList(0, 15, 'all', null, [], undefined)
  queryContactInfoList(
    page,
    size,
    type,
    companyName,
    mainContactPerson,
    citySite
  ) {
    return Api.queryContactInfoList(
      page,
      size,
      type,
      companyName,
      mainContactPerson,
      citySite
    ).then(
      (res) => this._processRes(res),
      (err) => console.error(err)
    );
  }
  //
  addContactInfo(data) {
    return Api.addContactInfo(data).then(
      (res) => this._processRes(res),
      (err) => console.error(err)
    );
  }
  editContactInfoDetail(data) {
    return Api.editContactInfoDetail(data).then(
      (res) => this._processRes(res),
      (err) => console.error(err)
    );
  }
  addContactPersonInfo(data) {
    return Api.addContactPersonInfo(data).then(
      (res) => this._processRes(res),
      (err) => console.error(err)
    );
  }
  editContactPersonDetail(data) {
    return Api.editContactPersonDetail(data).then(
      (res) => this._processRes(res),
      (err) => console.error(err)
    );
  }
  queryFilterEnums(data) {
    return Api.queryFilterEnums(data).then(
      (res) => this._processRes(res),
      (err) => console.error(err)
    );
  }
  deleteContactInfo(data) {
    return Api.deleteContactInfo(data).then(
      (res) => this._processRes(res),
      (err) => console.error(err)
    );
  }
  deleteContactPersonInfo(data) {
    return Api.deleteContactPersonInfo(data).then(
      (res) => this._processRes(res),
      (err) => console.error(err)
    );
  }
  //
}

let instance = null;

export function contactServerInit($bus) {
  instance = new ContactService($bus);
}

export function getContactServerInstance() {
  return instance;
}
